{"id":"TermsAndConditionsButton","prefabs":{"default":{"children":[{"component":"TermsAndConditionsButton","options":"options:*"}]}}}